import { render, staticRenderFns } from "./404.vue?vue&type=template&id=bc94081a&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=bc94081a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc94081a",
  null
  
)

export default component.exports